import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import { connect } from 'react-redux';

import { RadialGauge } from '@progress/kendo-react-gauges';

import * as classes from './ExecutiveSummaryScoreGuage.module.css';
import ExecutiveSummaryTile from '../../../components/ExecutiveSummaryTile';

const ExecutiveSummaryScoreGuage = ({
    bobLoading,
    sites,
    sitesMeta,
    ...props
}) => {
    const [value, setValue] = useState(0);

    useEffect(() => {
        if (!isEmpty(sitesMeta)) {
            let average = 0;

            sites.forEach(site => {
                average = average + site.siteScore;
            });
            average = (average / sitesMeta.totalRecordCount);
            if (!Number.isInteger(average)) {
                average = average.toFixed(2);
            }
            setValue(average);
        }
    }, [sitesMeta]);

    const radialOptions = {
        shape: 'arrow',
        scale: {
            minorTicks: {
                visible: false
            },
            majorTicks: {
                visible: false
            },
            rangeSize: 25,
            majorUnit: 20,
            max:       100,
            ranges:    [
                {
                    from:  0,
                    to:    40,
                    color: '#da1d28',
                },
                {
                    from:  40,
                    to:    75,
                    color: '#fd832a',
                },
                {
                    from:  75,
                    to:    100,
                    color: '#1fc854',
                },
            ],
        },
    };

    const renderLabel = () => {
        return (
            <div style={{textAlign: 'center'}}>
                <span>
                    <span className={classes.Fault} />
                    <span className={classes.FaultLabel}>Fault 0 - 39</span>
                </span>
                <span>
                    <span className={classes.Warning} />
                    <span className={classes.FaultLabel}>Warning 40 - 70</span>
                </span>
                <span>
                    <span className={classes.Good} />
                    <span className={classes.FaultLabel}>Good 71+</span>
                </span>
            </div>
        );
    };

    return (
        <ExecutiveSummaryTile isLoading={isEmpty(sitesMeta) || bobLoading.includes('FetchSiteScore')} label={renderLabel()}>
            {isEmpty(sitesMeta) || bobLoading.includes('FetchSiteScore') ?
                <div className={classes.Loader}>
                    <img src="/assets/images/BobLoaderLarge.gif" alt="loader" />
                </div>
                :
                <React.Fragment>
                    <RadialGauge
                        pointer={{
                            value: value,
                        }}
                        style={{ width: '250px', height: '225px' }}
                        {...radialOptions}
                    />
                    <div className={classes.Title}>
                        <div className={classes.Score}>{value}</div>
                        <div className={classes.Label}>Average Score</div>
                    </div>
                </React.Fragment>
            }
        </ExecutiveSummaryTile>
    );
};

const mapStateToProps = state => {
    return {
        bobLoading: state.bob.bobLoading,
        sites:      state.executiveSummary.sites,
        sitesMeta:  state.executiveSummary.sitesMeta
    };
};

export default connect(mapStateToProps, null)(ExecutiveSummaryScoreGuage);
